
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.647.898V.54c0-.298.252-.539.563-.539h5.54c.311 0 .563.241.563.54v.358c0 .298-.252.54-.562.54h-2.003v10.278c0 4.73-3.049 7.102-7.234 7.102-4.281 0-7.262-2.303-7.262-7.102V1.438H1.25a.551.551 0 01-.563-.54V.54C.687.241.94 0 1.25 0h5.54c.311 0 .563.241.563.54v.358c0 .298-.252.54-.562.54H4.788v10.226c0 3.921 2.215 5.731 5.699 5.731 3.548 0 5.725-1.944 5.725-5.782V1.438H14.21a.551.551 0 01-.563-.54zM0 22.102v.359c0 .298.252.539.563.539h19.875c.31 0 .562-.241.562-.54v-.358a.551.551 0 00-.563-.54H.563a.551.551 0 00-.562.54z","fill":"#262626"}})])
          )
        }
      }
    